/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import checkout from "./form";

const {
    formField: {
        name,
        short_description,
        email,
        phone,
        address,
        business_name,
        business_address,
        business_email,
        business_phone,
        specialty,
        bank,
        bank_account,
        badge,
        password,
        password_confirmation,
        account_name,
        account_email,
        rfc
    },
} = checkout;

const initialValues = {
    [name.name]: "",
    [short_description.name]: "",
    [email.name]: "",
    [phone.name]: "",
    [address.name]: "",
    [business_name.name]: "",
    [business_phone.name]: "",
    [business_email.name]: "",
    [business_address.name]: "",
    [specialty.name]: "",
    [badge.name]: "",
    [bank.name]: "",
    [bank_account.name]: "",
    [password.name]: "",
    [password_confirmation.name]: "",
    [account_name.name]: "",
    [account_email.name]: "",
    [rfc.name]: "",
};

export default initialValues;
